// ExternalCTA — the standard "go do this elsewhere" button: label + external
// icon, with tone variants. Used for the four process levers in Manage Account
// and any action that hands off to an external flow. From the prototype m2-cta.
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import { ExternalIcon } from '../../icons/Icons';
import './external-cta.css';

export function ExternalCTA({ tone = 'blue', onClick, fullWidth = false, className, children, ...rest }) {
  return (
    <button
      type="button"
      className={cx('external-cta', `external-cta--${tone}`, fullWidth && 'external-cta--full', className)}
      onClick={onClick}
      {...rest}
    >
      <span>{children}</span>
      <ExternalIcon />
    </button>
  );
}

ExternalCTA.propTypes = {
  tone: PropTypes.oneOf(['blue', 'green', 'purple', 'orange', 'neutral']),
  onClick: PropTypes.func,
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default ExternalCTA;
